import * as React from 'react';
import { Stack, Toggle } from '@fluentui/react';
import HeaderLogo from './HeaderLogo';
import HeaderMenu from './HeaderMenu';
import { UserContext } from '../../contexts/ContextWrapper';

interface HeaderProps {
	logout: () => void
	loggedIn: boolean
}

const Header: React.FC<HeaderProps> = (props) => {

	const { userContext, setUserContext } = React.useContext(UserContext)

	if (!props.loggedIn) {
		return (
			<Stack.Item className="ms-bgColor-white" styles={{ root: { padding: '20px' } }}>
				<HeaderLogo />
			</Stack.Item>
		)
	}

	return (
		<Stack.Item className="ms-bgColor-white" styles={{ root: { padding: '20px' } }}>
			<HeaderLogo>
				{userContext.userData?.isRehngruppen && <Toggle
					className='ms-hiddenMdDown'
					inlineLabel={true}
					label="Admin"
					checked={userContext.adminMode}
					onChange={(_ev, checked) => {
						localStorage.setItem('adminMode', checked!.toString())
						setUserContext(prev => ({ ...prev, adminMode: checked! }))
					}}
					styles={{ root: { margin: 5 } }}
				/>}
				<Stack.Item styles={{ root: { justifyContent: 'end' } }}>
					<Stack horizontal tokens={{ childrenGap: 5 }} verticalAlign='center'>
						<HeaderMenu logout={props.logout} />
					</Stack>
				</Stack.Item>
			</HeaderLogo>
		</Stack.Item>
	)
}

export default Header;
